<template>
  <v-img
    light
    src="@/assets/images/youth/BibleStudyBG.jpg"
  >
    <v-overlay absolute opacity="0.2">
      <v-container class="py-15">
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <h1 class="text-h4 mb-4 font-weight-regular" style="color:white">
              Join a group or one-on-one bible study session
            </h1>
            <v-btn
              large
              rounded
              elevation="4"
              color="#F44D40"
              class="px-10 font-weight-regular"
            >
              <div style="color:white">SIGN UP TODAY</div>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
  </v-img>
</template>

<script>
export default {
  name: 'YouthStudy'
}
</script>
